"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SttButton = _interopRequireDefault(require("./SttButton"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _ClearOutlined = _interopRequireDefault(require("@material-ui/icons/ClearOutlined"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SttSelectButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_SttButton["default"], _extends({}, props, {
    type: props.type || "button",
    variant: props.selected ? "contained" : "outlined",
    color: props.color || "primary",
    onClick: props.onClick || null,
    endIcon: props.selected && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      "aria-label": "home",
      onClick: function onClick(e) {
        e.stopPropagation();
        props.onClear && props.onClear(e);
      }
    }, /*#__PURE__*/_react["default"].createElement(_ClearOutlined["default"], {
      style: {
        color: '#ECFEDB'
      }
    })),
    disabled: props.disabled,
    nomarginleft: props.nomarginleft || undefined
  }), typeof props.children === 'function' ? props.children() : props.children);
}
var _default = SttSelectButton;
exports["default"] = _default;